<template>

  <form
      ref="form"
      :data-url='DESIGNATION'
      @submit.prevent="submitData"
  >
    <app-form-group
        :label="$t('name')"
        :placeholder="$placeholder('name')"
        v-model="formData.name"
        :required="true"
        :error-message="errors.name">
    </app-form-group>

    <app-form-group
        type="textarea"
        :label="$t('description')"
        :placeholder="$textAreaPlaceHolder('description')"
        v-model="formData.description"
        :required="true"
        :error-message="errors.description">
    </app-form-group>

  </form>
</template>

<script>
import FormHelperMixins from "../../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../../common/Mixin/Global/ModalMixin";
import {DESIGNATION, SELECTABLE_DEPARTMENT} from "../../../../Config/ApiUrl";
import {axiosGet} from "../../../../../common/Helper/AxiosHelper";

export default {
  name: "DefaultDesignationCreateEditModal",
  mixins: [FormHelperMixins, ModalMixin],
  props: {
    makeDefault: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        name: '',
        description: ''
      },
      designations: [],
      DESIGNATION,
      SELECTABLE_DEPARTMENT,
      errors: {}
    }
  },
  methods: {
    getFormData() {
      return this.formData;
    },
    validateForm(formData) {
      this.errors = {}; // Reset errors
      if (!formData.name.trim()) {
        this.errors.name = 'Name is required';
      }

      // Check if the form is valid (no errors)
      this.isValid = Object.keys(this.errors).length === 0;
      return this.isValid;
    },
    getDesignations() {
      axiosGet(this.apiUrl.DESIGNATION).then(({data}) => {
        this.designations = data.data;
      })
    },
    afterSuccess({data}) {
      this.formData = {};
      $('#designation-modal').modal('hide');
      this.$emit('input', false);
      this.toastAndReload(data.message, 'designation-table');
    },
    afterSuccessFromGetEditData(response) {
      this.preloader = false;
      this.formData = response.data;
    },
  },
}
</script>

